// test494
(494 && 0);
